import { createStmWithUpdateCosignToken, refreshCosignToken } from '@hooks-api/fortune/refreshCosignToken'
import { useMemo } from 'react'
import { getClient } from '../../../clients'
import { STM_COUNTRY_CONFIG } from '../constants'
import { useCountryCode } from '../hooks'

/**
 * 登入前（UnauthRoutes）用的 xpt refresh 元件。
 * Cosign 的登入 API（OTP 發送、驗證等）需要 x-platform-token header，
 * 此元件在登入頁 mount 時以 defaultCampaignCode 取得 xpt，
 * 並更新 cosign client 的 headers（cosign client 沒有 STM interceptor）。
 */
export const RefreshStmCosignToken = () => {
  const countryCode = useCountryCode()
  const defaultCampaignCode = STM_COUNTRY_CONFIG[countryCode]?.defaultCampaignCode

  const middleware = useMemo(
    () => defaultCampaignCode
      ? createStmWithUpdateCosignToken(defaultCampaignCode, [getClient('cosign')])
      : undefined,
    [defaultCampaignCode],
  )

  refreshCosignToken(
    defaultCampaignCode ? { code: defaultCampaignCode } : undefined,
    middleware ? { use: [middleware] } : undefined,
  )

  return null
}
